import { PageHeader, Section } from "@/components/Section";

export default function Terms() {
  return (
    <>
      <PageHeader
        overline="Legal"
        title="Terms of use."
        lede="The terms that govern visiting getcontinuum.com and using the waitlist forms. Platform terms (app.getcontinuum.com) are separate and accepted at sign-in."
        testid="terms-page-header"
      />
      <Section className="!pt-16">
        <div className="max-w-prose prose-continuum">
          <p>
            By accessing this site you agree to the terms below. If you do not agree, please
            stop using the site.
          </p>

          <h2>1. The site</h2>
          <p>
            <strong>getcontinuum.com</strong> is a marketing and information site for
            Continuum, a product of <strong>The Creative Coefficient</strong>. The platform
            application is delivered separately under its own master services agreement.
          </p>

          <h2>2. Accuracy and "in build" disclosure</h2>
          <p>
            Continuum is in active development. Pages on this site clearly mark what is shipped
            today vs. planned. We do not publish fabricated screenshots, invented statistics,
            or unapproved client material. Information may change between phase releases.
          </p>

          <h2>3. Acceptable use</h2>
          <ul>
            <li>No automated scraping or load testing without written permission.</li>
            <li>No submitting third-party personal data through our forms.</li>
            <li>No attempts to bypass the published methodology version stamps in any output we share.</li>
          </ul>

          <h2>4. Intellectual property</h2>
          <p>
            All site content, illustrations, and the Continuum name and gradient identity are
            the property of The Creative Coefficient. The methodology engine is versioned and
            documented publicly under terms described on the <a href="/method" className="text-[#FF8A00] font-bold underline">Method</a> page.
          </p>

          <h2>5. Liability</h2>
          <p>
            The site is provided as-is. Nothing on this page constitutes a contract for the
            platform itself — that contract is the platform MSA, signed separately. We are not
            liable for decisions made solely on the basis of marketing-site content.
          </p>

          <h2>6. Governing law</h2>
          <p>
            These terms are governed by the laws of Alberta, Canada, with venue in Alberta
            courts.
          </p>

          <h2>7. Contact</h2>
          <p>
            Questions about these terms go to{" "}
            <a href="mailto:hello@getcontinuum.com" className="text-[#FF8A00] font-bold underline underline-offset-4">hello@getcontinuum.com</a>.
          </p>
        </div>
      </Section>
    </>
  );
}
